import { useLayoutEffect, useState } from 'react';
import { Container, Card, Note, Info, Tag } from './styled';
import { getNote } from '../../service/serviceChat/chatService';
import { BsHeadset } from 'react-icons/bs';
import { maskZero, maskDate } from '../../utils';
import moment from 'moment';


export function NoteClient(props) {

    const { idNote } = props;

    const [notes, setNotes] = useState([]);


    useLayoutEffect(() => {
        async function searchNote() {
            setNotes(await getNote(idNote));
        }
        searchNote();
    }, [idNote]);


    const isNote = (note) => {
        if (note === undefined || !note || note === null || note === " " || note === "undefined" || note === "null") {
            return 'Não há anotações '
        } else {
            return <>{note}</>
        }
    }


    return (
        <Container>
            {notes?.map((item) =>
                <Card key={item.id}>
                    <Note>
                        <p>{isNote(item.note)}</p>
                    </Note>
                    <Info>
                        <Tag type='inFo'>
                            <p>{maskZero(item.id)}</p>
                        </Tag>
                        <Tag type='name'>
                            <span><BsHeadset /></span>
                            <p>{item.usuario}</p>
                        </Tag>
                        <Tag type='inFo'>
                            <p>{`Iniciado ${maskDate(item.started_at) + ' - ' + moment(item.started_at).format('HH:mm')}`}</p>
                        </Tag>
                        <Tag type='inFo'>
                            <p>{`${item.finished_at 
                                ? `Finalizado ${maskDate(item.finished_at) + ' - ' + moment(item.finished_at).format('HH:mm')}` 
                                : 'Aberto'}`}</p>
                        </Tag>
                    </Info>
                </Card>
            )}
        </Container>
    );
}